import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-circle-inverted",
  "use": "tamr-icon-circle-inverted-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"tamr-icon-circle-inverted\">\n  <circle cx=\"12.5\" cy=\"12.5\" r=\"12.5\" stroke=\"none\" stroke-width=\"1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol